const AgreeCheckbox = ({
    label,
    checked,
    onChange,
    id,
    disabled = false
}) => {
    return (
        <div className="flex items-center gap-3 my-3">
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            />
            <label
                htmlFor={id}
                className="text-sm font-medium text-gray-900 cursor-pointer"
            >
                {label}
            </label>
        </div>
    );
};

export default AgreeCheckbox;
